/* eslint-disable no-use-before-define */

const FENETRE_AGREGATION_MS = 90 * 1000;

// Ordre de priorité : recovery > runtime > finalize > convergence > upload > mémoire > autre
const FAMILLES = [
  { famille: 'recovery',    prefixes: ['RECOVERY_', 'CAMERA_RECOVERY_'] },
  { famille: 'finalize',    prefixes: ['CAMERA_FINALIZE_', 'FINALIZE_'] },
  { famille: 'convergence', prefixes: ['RAW_COPY_', 'RAW_CHECK', 'FIRST_BYTES', 'CONVERGENCE_', 'VIDEO_COPY_'] },
  { famille: 'upload',      prefixes: ['UPLOAD_', 'PUBLICATION_'] },
  { famille: 'runtime',     prefixes: ['RECORDING_STATE_', 'CAMERA_CRASH', 'CAMERA_RESTART', 'LIFECYCLE', 'VIDEO_INCIDENT', 'VIDEO_PERDUE'] },
  { famille: 'memoire',     prefixes: ['MEMORY_', 'MEMOIRE_', 'LOW_STORAGE', 'LOW_MEMORY'] },
];

function familleEvenement(evenement) {
  const type = String(evenement.evenement_type || '').toUpperCase();
  for (const { famille, prefixes } of FAMILLES) {
    if (prefixes.some((p) => type.startsWith(p) || type.includes(p))) return famille;
  }
  return 'autre';
}

function tsMs(evenement) {
  const ts = evenement.ts_event || evenement.recu_at;
  if (!ts) return null;
  const d = new Date(ts);
  return Number.isNaN(d.getTime()) ? null : d.getTime();
}

function severiteIncident(evenements) {
  const niveaux = evenements.map((e) => String(e.severite_operationnelle || e.niveau || '').toUpperCase());
  if (niveaux.some((n) => n === 'CRITIQUE' || n === 'CRITICAL')) return 'CRITIQUE';
  if (niveaux.some((n) => n === 'DEGRADE' || n === 'WARNING' || n === 'WARN')) return 'DEGRADE';
  return 'INFO';
}

function typePrincipalIncident(familles) {
  const ordrePrioritaire = ['recovery', 'runtime', 'finalize', 'convergence', 'upload', 'memoire', 'autre'];
  const comptes = {};
  familles.forEach((f) => { comptes[f] = (comptes[f] || 0) + 1; });
  for (const type of ordrePrioritaire) {
    if (comptes[type]) return type;
  }
  return 'autre';
}

function resumeIncident(familles) {
  const uniques = [...new Set(familles)];
  if (uniques.includes('recovery') && uniques.includes('runtime')) return 'Crash + tentative recovery';
  if (uniques.includes('recovery') && uniques.includes('finalize')) return 'Finalisation + recovery';
  if (uniques.includes('recovery') && uniques.includes('convergence')) return 'Recovery + convergence RAW';
  if (uniques.includes('recovery')) return 'Séquence recovery';
  if (uniques.includes('runtime')) return 'Incident runtime';
  if (uniques.includes('finalize')) return 'Problème finalisation';
  if (uniques.includes('convergence')) return 'Convergence RAW en cours';
  if (uniques.includes('upload')) return 'Blocage upload';
  if (uniques.includes('memoire')) return 'Mémoire critique';
  return 'Événement isolé';
}

function construireIncident(cameraId, groupe) {
  const evs = groupe.map((item) => item.ev);
  const debut = groupe[0].ts;
  const fin = groupe[groupe.length - 1].ts;
  const familles = evs.map(familleEvenement);
  const typePrincipal = typePrincipalIncident(familles);

  return {
    incidentId: `${cameraId}-${debut}`,
    cameraId,
    debut,
    fin,
    duree: Math.round((fin - debut) / 1000),
    typePrincipal,
    severite: severiteIncident(evs),
    confiance: groupe.length >= 3 ? 'haute' : groupe.length >= 2 ? 'moyenne' : 'faible',
    resume: resumeIncident(familles),
    evenements: evs,
    nbEvenements: evs.length,
  };
}

// Règle déterministe :
//   SI même cameraId ET événements dans fenêtre 90s → un incident unique.
//   Pas d'IA, pas de scoring opaque.
export function agregerEvenementsEnIncidents(evenements) {
  const avecTs = (evenements || [])
    .map((ev) => ({ ev, ts: tsMs(ev) }))
    .filter((item) => item.ts !== null)
    .sort((a, b) => a.ts - b.ts);

  if (avecTs.length === 0) return [];

  const parCamera = {};
  avecTs.forEach(({ ev, ts }) => {
    const cam = ev.cam_id || ev.tel_id || 'inconnu';
    if (!parCamera[cam]) parCamera[cam] = [];
    parCamera[cam].push({ ev, ts });
  });

  const incidents = [];

  Object.keys(parCamera).forEach((cameraId) => {
    const evCamera = parCamera[cameraId];
    let groupeCourant = [evCamera[0]];

    for (let i = 1; i < evCamera.length; i++) {
      const item = evCamera[i];
      const dernier = groupeCourant[groupeCourant.length - 1];
      if (item.ts - dernier.ts <= FENETRE_AGREGATION_MS) {
        groupeCourant.push(item);
      } else {
        incidents.push(construireIncident(cameraId, groupeCourant));
        groupeCourant = [item];
      }
    }
    incidents.push(construireIncident(cameraId, groupeCourant));
  });

  return incidents.sort((a, b) => b.debut - a.debut);
}



// WEBPACK FOOTER //
// src/components/cockpit/incidentAggregateur.js